import { Button } from '@nextui-org/react';
import IconComponent from 'components/IconComponent';
import { MainContext } from 'contexts/MainContext';
import { useContext } from 'react';
import CategoryElement from 'views/Order/Categories/V2CategorySelector/CategoryElement';

function V2CategorySelector({ categoryTree, addRefToArray, scrollToElement, categories, selectedCategory, setSelectedCategory, filterFunction }) {

  const { setShowAllCategoriesModal } = useContext(MainContext);

  return (
    <div className='w-full flex flex-row overflow-hidden min-h-[2.5rem] items-center justify-center pl-2'>
      <Button onPress={() => setShowAllCategoriesModal(true)} size='sm' isIconOnly className='mr-2'>
        <div className='w-4 h-4'>
          <IconComponent iconCode={'list'} className={'current'} />
        </div>
      </Button>
      <div className={`grow flex flex-row overflow-x-auto `}>
        {categoryTree.filter(filterFunction).map((category) => {
          return (
            <>
              <CategoryElement
                key={category?.uuid}
                categoryUUID={category.uuid}
                categories={categories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                addRefToArray={addRefToArray}
                scrollToElement={scrollToElement}
              />
              {category.categories.length > 0 &&
                category.categories
                  .filter(filterFunction)
                  .map((subCategory) => (
                    <CategoryElement
                      key={subCategory.uuid}
                      categoryUUID={subCategory.uuid}
                      categories={categories}
                      selectedCategory={selectedCategory}
                      setSelectedCategory={setSelectedCategory}
                      addRefToArray={addRefToArray}
                      scrollToElement={scrollToElement}
                    />
                  ))}
            </>
          );
        })}
      </div>
    </div>
  );
}

export default V2CategorySelector;
